export default {
  components: {
    dialogBody: 'dt.designSystem.components.dialogBody',
    segmentedControl: {
      activeIndicator: 'dt.designSystem.components.segmentedControl.activeIndicator',
      link: 'dt.designSystem.components.segmentedControl.link',
    },
  },
};
